import { CompetentionsIndicators } from './CompetentionsIndicators';

export default CompetentionsIndicators;